import {inject, Injectable} from '@angular/core';
import {NotificationService} from './notification-center.service';
import {NotificationsStore} from './notification.store';
import {NotificationWebSocketService} from './notification-web-socket.service';
import {mapNotification} from './notification.mapper';
import {forkJoin} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationsFacade {
	private service = inject(NotificationService)
	private store = inject(NotificationsStore)
	private ws = inject(NotificationWebSocketService)

	getAllNotifications(userId: string) {
		this.service.getAll(userId).subscribe({
			next: notifications =>
				this.store.setNotifications(
					notifications.map(mapNotification)
				),
			error: () => this.store.setError('Errore nel caricamento delle notifiche')
		});
	}

	connectWebsocket(token: string) {
		this.ws.connect(token, payload => {
			const notification = mapNotification(payload);

			this.store.addNotification(notification);
		});
	}

	disconnectWebsocket() {
		this.ws.disconnect();
	}

	markAsReaded(notificationId: string) {

		const previous = this.store.notifications().find(n => n.id === notificationId);

		if (!previous || previous.read) return;

		this.service.setAsRead(notificationId).subscribe({
			next: () => {
				this.store.updateNotification({
					id: notificationId,
					read: true
				})
			},
			error: () => {
				this.store.updateNotification({
					id: notificationId,
					read: previous.read
				});

				this.store.setError('Errore nel salvataggio della notifica');
			}
		});
	}

	markAllAsRead() {

		const unread = this.store.notifications().filter(n => !n.read);

		if (!unread.length) return;

		const previous = this.store.notifications();
		this.store.markAllAsRead();

		const requests = unread.map(n =>
			this.service.setAsRead(n.id)
		);

		forkJoin(requests).subscribe({
			error: () => {
				this.store.setNotifications(previous);
				this.store.setError('Errore nel salvataggio delle notifiche');
			}
		});
	}



}
